export const notificationsEn = {
  notificationSystem: {
    title: "Notification System",
    subtitle: "Send real emails and SMS. Configure automated weekly reports.",
    sendNotifications: "Send Notifications",
    history: "History",
    weeklyReports: "Weekly Reports",
    emailNotification: "Email Notification",
    recipientEmail: "Recipient Email",
    subject: "Subject",
    subjectPlaceholder: "Alert: High risk detected in your parcel",
    message: "Message",
    messagePlaceholder: "Your parcel 'North Vineyard' shows NDVI below threshold...",
    sendEmail: "Send Email",
    smsNotification: "SMS Notification",
    phoneNumber: "Phone Number",
    smsPlaceholder: "ALERT: North Vineyard parcel shows high risk conditions. Review dashboard immediately.",
    characters: "characters",
    sendSms: "Send SMS",
    weeklyReport: "Weekly Report",
    sendWeeklyReportDesc: "Send a comprehensive weekly report now",
    generateAndSend: "Generate and Send Weekly Report Now",
    notificationHistory: "Notification History",
    noNotifications: "No notifications sent yet",
    automatedConfig: "Automated Weekly Reports Configuration",
    automatedConfigDesc: "Weekly reports are sent automatically every Monday at 06:00 UTC",
    automatedActive: "Automated Reports Active",
    automatedActiveDesc: "Weekly reports are generated and sent automatically every Monday at 06:00 UTC for all users with registered email.",
    reportIncludes: "Weekly Report Includes:",
    reportItem1: "Summary of all parcel analyses",
    reportItem2: "NDVI trends and changes",
    reportItem3: "Weather patterns and forecasts",
    reportItem4: "Risk assessments and alerts",
    reportItem5: "Insurance claim status updates",
    reportItem6: "Actionable recommendations",
    autoScheduling: "Auto Scheduling",
    nextScheduledReport: "Next scheduled report: Monday 06:00 UTC",
    reportsProcessed: "Reports are automatically processed and sent via email to all registered users.",
    invalidEmail: "Invalid Email",
    invalidEmails: "Invalid Email Addresses",
    notificationSimulated: "Notification Simulated",
    notificationSent: "Notification Sent",
    generatingReport: "Generating Report",
    generatingReportDesc: "Creating your weekly report...",
    weeklyReportQueued: "Weekly Report Queued",
    weeklyReportQueuedDesc: "Your weekly report has been generated and queued for email delivery. Check your notification logs shortly.",
    errorSending: "Error sending notification. Please try again.",
    errorWeeklyReport: "Error generating weekly report. Please try again.",
    mustBeLoggedIn: "You must be logged in to send notifications",
    mustBeLoggedInReports: "You must be logged in to send weekly reports"
  }
};
